<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "Test",
  data() {
    return {
      moment,
      vacancies: [],
      formData: {
        regionId: null,
        vacancyId: null,
        photoHashId: null,
        bodyPictureHashId: null,
        passportHashId: null,
        resumeHashId: null,
        personalDataSheetHashId: null,
        diplomaHashIds: [],
        transcriptHashIds: [],
        otherHashIds: [],
        token: null,
        weight: null,
        height: null,
        phone: null,
        extraPhone: null,
        lang: null,
      },
      phoneRaw: '',
      extraPhoneRaw: '',
      dialogVisible: false,
      photoUploading: false,
      bodyPictureUploading: false,
      passportUploading: false,
      resumeUploading: false,
      personalDataSheetUploading: false,
      diplomaUploading: false,
      transcriptUploading: false,
      otherUploading: false,
      branches: [],
      selectedBranchId: null,
      vacancyDrawerVisible: false,
      panding: false,
      rules: {
        regionId: [
          { required: true, message: this.$t('dictionary.select_region'), trigger: "blur" }
        ],
        vacancyId: [
          {required: true, message: this.$t('dictionary.select_vacancy'), trigger: "blur"},
        ],
        photoHashId: [
          {required: true, message: this.$t('dictionary.upload_image'), trigger: "blur"},
        ],
        bodyPictureHashId: [
          {required: true, message: this.$t('dictionary.upload_body_image'), trigger: "blur"},
        ],
        passportHashId: [
          {required: true, message: this.$t('dictionary.upload_passport'), trigger: "blur"},
        ],
        resumeHashId: [
          {required: true, message: this.$t('dictionary.upload_resume'), trigger: "blur"},
        ],
        personalDataSheetHashId: [
          {required: true, message: this.$t('dictionary.upload_objective'), trigger: "blur"},
        ],
        diplomaHashIds: [
          {required: true, message: this.$t('dictionary.upload_diploma'), trigger: "blur"},
        ],
        transcriptHashIds: [
          {required: true, message: this.$t('dictionary.upload_transcript'), trigger: "blur"},
        ],
        weight: [
          {required: true, message: this.$t('dictionary.enter_weight'), trigger: "blur"},
        ],
        height: [
          {required: true, message: this.$t('dictionary.enter_height'), trigger: "blur"},
        ],
        phone: [
          {required: true, message: this.$t('dictionary.enter_phone'), trigger: "blur"},
        ],
      },
      confirm: false,
      activeTab: 'uz-lat',
      ofertaDialogVisible: false,
      samplePreviewVisible: false,
      samplePreviewImage: '',
      videoDialogVisible: false,
      videoUrl: null,
      regions: []
    }
  },
  methods: {
    openPopup() {
      const params = {
        response_type: 'one_code',
        client_id: 'prokuratura_uz',
        redirect_uri: 'https://prokuratura.uz/vacancy',
        scope: 'prokuratura_uz',
        state: 'realState'
      };
      const query = new URLSearchParams(params).toString();
      const width = 1080;
      const height = 720;
      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height / 2) - (height / 2);
      const features = `width=${width},height=${height},left=${left},top=${top}`;
      window.open(`https://sso.egov.uz/sso/oauth/Authorization.do?${query}`, "popup", features);
      window.addEventListener("message", (event) => {
        if (event.data.code) {
          this.requestAccessTocken(event.data.code);
        }
      });
    },
    requestAccessTocken(code) {
      const params = {
        code: code,
      };
      const query = new URLSearchParams(params).toString();
      axios.get(`/one-id/token?${query}`)
          .then(({data}) => {
            this.$store.commit("setOneIdToken", data.access_token);
            this.requestData();
          })
          .catch((error) => {
            this.$store.commit("clearOneId");
          })
    },
    requestData() {
      const params = {
        token: this.$store.state.oneId.accessToken,
      };
      const query = new URLSearchParams(params).toString();
      axios.get(`/one-id/data?${query}`)
          .then(({data}) => {
            this.$store.commit("setOneIdInfo", data);
          })
          .catch((error) => {
            this.$store.commit("clearOneId");
          })
    },
    loadBranches() {
      axios.get(`/nomzod/branch/prosecutor`)
          .then(({data}) => {
            this.branches = data;
          })
    },
    loadRegions() {
      axios.get(`/nomzod/region`)
        .then(({data}) => {
          this.regions = data;
        })
    },
    logout() {
      const params = {
        token: this.$store.state.oneId.accessToken,
      };
      const query = new URLSearchParams(params).toString();
      axios.get(`/one-id/logout?${query}`)
          .then(({data}) => {
            alert("Logout successfully");
            this.$store.commit("clearOneId");
          })
          .catch((error) => {
            this.$store.commit("clearOneId");
          })
    },
    async loadVacancies() {
      const params = {};
      if (this.selectedBranchId) params.branchId = this.selectedBranchId;
      const query = new URLSearchParams(params).toString();
      await axios.get(`/nomzod/vacancy/prosecutor?${query}`)
          .then(({data}) => {
            this.vacancies = data;
          })
    },
    apply(id) {
      this.formData.lang = this.$i18n.locale;
      this.formData.regionId = null;
      this.formData.vacancyId = id;
      this.formData.photoHashId = null;
      this.formData.bodyPictureHashId = null;
      this.formData.passportHashId = null;
      this.formData.resumeHashId = null;
      this.formData.personalDataSheetHashId = null;
      this.formData.diplomaHashIds = [];
      this.formData.transcriptHashIds = [];
      this.formData.otherHashIds = [];
      this.formData.token = this.$store.state.oneId.accessToken;
      this.formData.weight = undefined;
      this.formData.height = undefined;
      this.formData.phone = null;
      this.formData.extraPhone = null;
      this.phoneRaw = '';
      this.extraPhoneRaw = '';
      this.dialogVisible = true;
      this.confirm = false;
      this.$nextTick(() => {
        this.$refs["photo_upload"].clearFiles();
        this.$refs["body_picture_upload"].clearFiles();
        this.$refs["passport_upload"].clearFiles();
        this.$refs["resume_upload"].clearFiles();
        this.$refs["personal_data_sheet_upload"].clearFiles();
        this.$refs["diploma_upload"].clearFiles();
        this.$refs["transcript_upload"].clearFiles();
        this.$refs["other_upload"].clearFiles();
      });
    },
    totalCounter(type) {
      let total = null
      for (let i = 0; i < this.branches.length; i++) {
        total += this.branches[i][type];
      }
      return total;
    },
    async saveRequest() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.panding = true;
          axios.post(`/nomzod/applicant`, this.formData)
              .then(({data}) => {
                this.$message.success(this.$t("dictionary.application_sent"));
                this.dialogVisible = false;
                this.vacancyDrawerVisible = false;
                this.loadVacancies();
                this.$router.push('/my-applications');
              })
              .catch(error => {
                this.$message.error(this.$t("dictionary.applicant_restirction_message"));
              })
              .finally(() => {
                this.panding = false;
              })
        }
      });
    },
    onSuccessPhotoUpload(res, file) {
      this.formData.photoHashId = res.hashId;
      this.photoUploading = false;
    },
    beforePhotoUpload(file) {
      const isLt1Mb = file.size / 1024 / 1024 < 20;

      if (!isLt1Mb) {
        this.$message.error(this.$t('dictionary.max_file_size'));
        return false;
      }

      this.photoUploading = true;
      return true;
    },
    onSuccessBodyPictureUpload(res, file) {
      this.formData.bodyPictureHashId = res.hashId;
      this.bodyPictureUploading = false;
    },
    beforeBodyPictureUpload(file) {
      const isLt1Mb = file.size / 1024 / 1024 < 20;

      if (!isLt1Mb) {
        this.$message.error(this.$t('max_file_size'));
        return false;
      }

      this.bodyPictureUploading = true;
      return true;
    },
    onSuccessPassportUpload(res, file) {
      this.formData.passportHashId = res.hashId;
      this.passportUploading = false;
    },
    beforePassportUpload(file) {
      const isLt1Mb = file.size / 1024 / 1024 < 20;

      if (!isLt1Mb) {
        this.$message.error(this.$t('max_file_size'));
        return false;
      }

      this.passportUploading = true;
      return true;
    },
    onSuccessResumeUpload(res, file) {
      this.formData.resumeHashId = res.hashId;
      this.resumeUploading = false;
    },
    beforeResumeUpload(file) {
      const isLt1Mb = file.size / 1024 / 1024 < 20;

      if (!isLt1Mb) {
        this.$message.error(this.$t('max_file_size'));
        return false;
      }

      this.resumeUploading = true;
      return true;
    },
    onSuccessPersonalDataSheetUpload(res, file) {
      this.formData.personalDataSheetHashId = res.hashId;
      this.personalDataSheetUploading = false;
    },
    beforePersonalDataSheetUpload(file) {
      const isLt1Mb = file.size / 1024 / 1024 < 20;

      if (!isLt1Mb) {
        this.$message.error(this.$t('max_file_size'));
        return false;
      }

      this.personalDataSheetUploading = true;
      return true;
    },
    onSuccessDiplomaUpload(res, file) {
      this.formData.diplomaHashIds.push(res.hashId);
      this.diplomaUploading = false;
    },
    beforeDiplomaUpload(file) {
      const isLt1Mb = file.size / 1024 / 1024 < 20;

      if (!isLt1Mb) {
        this.$message.error(this.$t('max_file_size'));
        return false;
      }

      this.diplomaUploading = true;
      return true;
    },
    onSuccessTranscriptUpload(res, file) {
      this.formData.transcriptHashIds.push(res.hashId);
      this.transcriptUploading = false;
    },
    beforeTranscriptUpload(file) {
      const isLt1Mb = file.size / 1024 / 1024 < 20;

      if (!isLt1Mb) {
        this.$message.error(this.$t('max_file_size'));
        return false;
      }

      this.transcriptUploading = true;
      return true;
    },
    onSuccessOtherUpload(res, file) {
      this.formData.otherHashIds.push(res.hashId);
      this.otherUploading = false;
    },
    beforeOtherUpload(file) {
      const isLt1Mb = file.size / 1024 / 1024 < 20;

      if (!isLt1Mb) {
        this.$message.error(this.$t('max_file_size'));
        return false;
      }

      this.otherUploading = true;
      return true;
    },
    goToMyApplications() {
      this.$router.push('/my-applications');
    },
    goToAnnouncement() {
      this.$router.push('/announcement');
    },
    showVacancies(branchId) {
      if(this.$i18n.locale != "en-US") {
        this.selectedBranchId = branchId;
        this.loadVacancies();
        this.vacancyDrawerVisible = true;
      }
    },
    onPhoneInput(val) {
      const digits = val.replace(/\D/g, '').slice(0, 9);
      this.phoneRaw = digits;
      let formatted = '';
      for (let i = 0; i < digits.length; i++) {
        if (i === 2 || i === 5 || i === 7) formatted += ' ';
        formatted += digits[i];
      }
      this.$nextTick(() => {
        this.formData.phone = '+998' + digits;
      });
      return formatted;
    },
    onExtraPhoneInput(val) {
      const digits = val.replace(/\D/g, '').slice(0, 9);
      this.extraPhoneRaw = digits;
      let formatted = '';
      for (let i = 0; i < digits.length; i++) {
        if (i === 2 || i === 5 || i === 7) formatted += ' ';
        formatted += digits[i];
      }
      this.$nextTick(() => {
        this.formData.extraPhone = '+998' + digits;
      });
      return formatted;
    },
    openSamplePreview(src) {
      this.samplePreviewImage = src;
      this.samplePreviewVisible = true;
    },
    getBranchNameByLangCode(branch){
      var str;
      switch(this.$i18n.locale){
        case "uz-UZ":
          str = branch.nameUz;
          break;
        case "uz-CYR":
          str = branch.nameCyr;
          break;
        case "uz-QR":
          str = branch.nameKk;
          break;
        case "ru-RU":
          str = branch.nameRu;
          break;
        case "en-US":
          str = branch.nameEn;
          break;
      }
      return str;
    },
    getVacancyBranchByLangCode(vacancy){
      var str;
      switch(this.$i18n.locale){
        case "uz-UZ":
          str = vacancy.branchUz;
          break;
        case "uz-CYR":
          str = vacancy.branchCyr;
          break;
        case "uz-QR":
          str = vacancy.branchKk;
          break;
        case "ru-RU":
          str = vacancy.branchRu;
          break;
        case "en-US":
          str = vacancy.branchEn;
          break;
      }
      return str;
    },
    getVacancyPositionByLangCode(vacancy){
      var str;
      switch(this.$i18n.locale){
        case "uz-UZ":
          str = vacancy.positionUz;
          break;
        case "uz-CYR":
          str = vacancy.positionCyr;
          break;
        case "uz-QR":
          str = vacancy.positionKk;
          break;
        case "ru-RU":
          str = vacancy.positionRu;
          break;
        case "en-US":
          str = vacancy.positionEn;
          break;
      }
      return str;
    },
    showVideoDialog(){
      switch(this.$i18n.locale){
        case "uz-UZ":
          this.videoUrl = "NomzodUZ.mp4";
          break;
        case "uz-CYR":
          this.videoUrl = "NomzodUZ.mp4";
          break;
        case "uz-QR":
          this.videoUrl = "NomzodQR.mp4";
          break;
        case "ru-RU":
          this.videoUrl = "NomzodRU.mp4";
          break;
        case "en-US":
          this.videoUrl = "NomzodUZ.mp4";
          break;
      }
      this.videoDialogVisible = true;
    },
    videoDialogClose(){
      this.videoUrl = null;
    }
  },
  computed: {
    oneIdInfo() {
      return this.$store.state.oneId.info;
    },
    isLoggedIn() {
      return !!(this.$store.state.oneId && this.$store.state.oneId.accessToken);
    },
    photoSource() {
      if (this.formData.photoHashId != null) return "/nomzod/file/preview/" + this.formData.photoHashId;
      else return null;
    },
    bodyPictureSource() {
      if (this.formData.bodyPictureHashId != null) return "/nomzod/file/preview/" + this.formData.bodyPictureHashId;
      else return null;
    },
    phoneMasked: {
      get() {
        const digits = this.phoneRaw || '';
        let formatted = '';
        for (let i = 0; i < digits.length; i++) {
          if (i === 2 || i === 5 || i === 7) formatted += ' ';
          formatted += digits[i];
        }
        return formatted;
      },
      set(val) {
        this.onPhoneInput(val);
      }
    },
    extraPhoneMasked: {
      get() {
        const digits = this.extraPhoneRaw || '';
        let formatted = '';
        for (let i = 0; i < digits.length; i++) {
          if (i === 2 || i === 5 || i === 7) formatted += ' ';
          formatted += digits[i];
        }
        return formatted;
      },
      set(val) {
        this.onExtraPhoneInput(val);
      }
    },
    getImageSourceByLangCode(){
      var src;
      switch(this.$i18n.locale){
        case "uz-UZ":
          src = "Вакансия лотин.png";
          break;
        case "uz-CYR":
          src = "Вакансия кирилл.png";
          break;
        case "uz-QR":
          src = "Вакансия ҚҚР.png";
          break;
        case "ru-RU":
          src = "Вакансия рус.png";
          break;
        case "en-US":
          src = "Вакансия лотин.png";
          break;
      }
      return src;
    },
    getDocByLangCode(){
      var src;
      switch(this.$i18n.locale){
        case "uz-UZ":
          src = "ТАНЛОВДА ИШТИРОК ЭТИШ ТАРТИБИ.pdf";
          break;
        case "uz-CYR":
          src = "ТАНЛОВДА ИШТИРОК ЭТИШ ТАРТИБИ.pdf";
          break;
        case "uz-QR":
          src = "ТАНЛОВДА ИШТИРОК ЭТИШ ТАРТИБИ.pdf";
          break;
        case "ru-RU":
          src = "ПОРЯДОК УЧАСТИЯ В КОНКУРСЕ.pdf";
          break;
        case "en-US":
          src = "ТАНЛОВДА ИШТИРОК ЭТИШ ТАРТИБИ.pdf";
          break;
      }
      return src;
    },
  },
  mounted() {
    const query = this.$route.query;
    if (query.code) {
      window.opener.postMessage({
        code: query.code
      }, "*");
      window.close();
    }
    this.loadRegions();
    this.requestData();
    this.loadVacancies();
    this.loadBranches();
  }
}
</script>

<template>
  <div class="py-4 bg-secondary">
    <div class="profile-page">
      <section class="section-new">
        <div class="container">
          <el-row>
            <el-col :span="24">
              <div class="card card-lift shadow border-0 card-address_page mb-3">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                  <el-breadcrumb-item :to="{ path: '/' }">{{ $t('menu.main') }}</el-breadcrumb-item>
                  <el-breadcrumb-item>{{ $t('menu.vacancy') }}</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
    </div>
    <section class="section py-3">
      <div class="container" style="min-height: 960px;">

<!--        <div class="vp-error-notice">-->
<!--          <i class="el-icon-warning"></i>-->
<!--          <span>{{ $t('dictionary.error_notify_message') }}</span>-->
<!--        </div>-->

        <div class="vp-info-notice">
          <i class="el-icon-info"></i>
          <span>{{ $t('dictionary.announcement') }}</span>
        </div>

        <!-- Suhbat yakunlari ma'lumotnomasi -->
        <article class="vp-report">
          <header class="vp-report__header">
            <h2 class="vp-report__title">{{ $t('dictionary.interview_report_title') }}</h2>
            <p class="vp-report__subtitle">{{ $t('dictionary.interview_report_subtitle') }}</p>
          </header>

          <div class="vp-report__body">
            <p v-html="$t('dictionary.interview_report_p1')"></p>
            <p v-html="$t('dictionary.interview_report_p2')"></p>
            <p v-html="$t('dictionary.interview_report_p3')"></p>
            <p v-html="$t('dictionary.interview_report_p4')"></p>
          </div>

          <footer class="vp-report__footer">
            {{ $t('dictionary.interview_report_footer') }}
          </footer>
        </article>

        <!-- User auth bar -->
        <div class="vp-user-bar">
          <div class="vp-user-bar__info">
<!--            <div class="vp-user-bar__notice">-->
<!--              <i class="el-icon-warning-outline"></i>-->
<!--              <span>{{ $t('dictionary.test_mode') }}</span>-->
<!--            </div>-->
            <div v-if="!isLoggedIn" class="vp-user-bar__login">
              <p class="vp-user-bar__login-text">{{ $t('dictionary.register_message') }}</p>
              <el-button type="success" @click="openPopup" size="small" class="vp-btn-oneid">
                <i class="el-icon-key"></i> {{ $t('dictionary.login') }}
              </el-button>
            </div>
            <div v-else class="vp-user-bar__profile">
              <div class="vp-user-bar__avatar">
                <i class="el-icon-user-solid"></i>
              </div>
              <span class="vp-user-bar__name">{{ oneIdInfo.full_name }}</span>
            </div>
          </div>
          <div style="display: flex;">
            <el-button size="small" @click="showVideoDialog" class="vp-btn-apps">
              <i class="el-icon-question"></i> {{$t('dictionary.video_tutorial')}}
            </el-button>
            <div v-if="isLoggedIn" class="vp-user-bar__actions" style="margin-left: 20px;">
              <el-button size="small" @click="goToMyApplications" class="vp-btn-apps">
                <i class="el-icon-document"></i> {{$t('menu.my_applications')}}
              </el-button>
              <el-button size="small" @click="logout" class="vp-btn-logout">
                {{ $t('dictionary.logout') }} <i class="el-icon-right"></i>
              </el-button>
            </div>
          </div>
        </div>

        <!-- Main content -->
        <div class="vp-content" v-if="vacancies.length > 0" style="display: none;">

          <!-- Branch cards grid -->
           <div style="flex: 1;">
            <div class="vp-section-title">
              <i class="el-icon-office-building"></i> {{ $t('dictionary.region_list') }}
            </div>
            <div class="vp-branch-grid">
              <div class="vp-branch-tile" v-for="(branch, idx) in branches.filter(b => b.vacancyCount !== 0)" :key="branch.id" @click="showVacancies(branch.id)">
                <div class="vp-branch-tile__accent"></div>
                <div class="vp-branch-tile__body">
                  <div class="vp-branch-tile__icon">
                    <i class="el-icon-office-building"></i>
                  </div>
                  <h4 class="vp-branch-tile__name">{{ getBranchNameByLangCode(branch) }}</h4>
                  <div class="vp-branch-tile__stats">
                    <span class="vp-branch-tile__count">
                      <i class="el-icon-folder-opened"></i> {{ branch.vacancyCount }}
                    </span>
                    <span class="vp-branch-tile__label">{{ $t('dictionary.vacancy') }}</span>
                  </div>
                  <el-button type="primary" size="mini" class="vp-branch-tile__btn">
                    <i class="el-icon-view"></i> {{ $t('dictionary.view') }}
                  </el-button>
                </div>
              </div>
            </div>
           </div>

           <div style="flex: 1;">
            <!-- Statistics table -->
            <div class="vp-section-title">
              <i class="el-icon-data-analysis"></i> {{ $t('dictionary.statistics') }}
            </div>
            <div class="vp-stats-card">
              <table class="vp-table">
                <thead>
                  <tr>
                    <th>{{ $t('dictionary.region') }}</th>
                    <th>{{ $t('dictionary.vacancies') }}</th>
                    <th>{{ $t('dictionary.applicants') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="branch in branches.filter(b => b.vacancyCount !== 0)" :key="branch.id">
                    <td>{{ getBranchNameByLangCode(branch) }}</td>
                    <td class="vp-table__center">{{ branch.vacancyCount }}</td>
                    <td class="vp-table__center">{{ branch.applicantCount }}</td>
                  </tr>
                  <tr class="vp-table__total">
                    <td>{{ $t('dictionary.total') }}</td>
                    <td class="vp-table__center">{{ totalCounter('vacancyCount') }}</td>
                    <td class="vp-table__center">{{ totalCounter('applicantCount') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
           </div>




        </div>
      </div>
    </section>
    <!-- ===== Ариза яратиш Modal ===== -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="80%"
      top="18vh"
      custom-class="ariza-dialog"
      :show-close="true"
      :close-on-click-modal="false">

      <!-- Custom header -->
      <template #title>
        <div class="ariza-dialog__header">
          <i class="el-icon-document-add ariza-dialog__header-icon"></i>
          <span>{{ $t('dictionary.create_application') }}</span>
        </div>
      </template>

      <div class="ariza-dialog__body">
        <el-form ref="form" :model="formData" :rules="rules" label-position="top">

          <!-- ── Top section: Photos + Documents ── -->
          <div class="ariza-grid-top">

            <!-- Left: Photo uploads + sample -->
            <div class="ariza-card ariza-card--photos">
              <div class="ariza-photos-row">

                <!-- Sample images -->
                <div class="ariza-photo-block ariza-photo-block--sample">
                  <span class="ariza-label">{{ $t('dictionary.image_sample') }}</span>
                  <div class="ariza-sample-images">
                    <div class="ariza-sample-item">
                      <img src="Расим намуна.png" class="ariza-sample-img" alt="Намуна">
                      <el-button
                        class="ariza-sample-zoom-btn"
                        circle
                        size="mini"
                        @click="openSamplePreview('Расим намуна.png')">
                        <i class="el-icon-zoom-in"></i>
                      </el-button>
                    </div>
                    <div class="ariza-sample-item">
                      <img src="Расим намуна 2.png" class="ariza-sample-img" alt="Намуна 2">
                      <el-button
                        class="ariza-sample-zoom-btn"
                        circle
                        size="mini"
                        @click="openSamplePreview('Расим намуна 2.png')">
                        <i class="el-icon-zoom-in"></i>
                      </el-button>
                    </div>
                  </div>
                  <p class="ariza-sample-caption">3х4 / 10х15 {{ $t('dictionary.size') }}</p>
                </div>

                <div class="ariza-photo-uploads-row">
                <!-- 3x4 photo -->
                <div class="ariza-photo-block">
                  <el-form-item prop="photoHashId">
                    <span class="ariza-label"><span class="ariza-label__req">*</span> {{ $t('dictionary.image') }}</span>
                    <el-upload
                      ref="photo_upload"
                      class="ariza-photo-uploader"
                      action="/nomzod/file/upload?docType=PHOTO"
                      :disabled="photoUploading"
                      :show-file-list="false"
                      :on-success="onSuccessPhotoUpload"
                      :before-upload="beforePhotoUpload">
                      <img v-if="photoSource" :src="photoSource" class="ariza-photo-preview">
                      <i v-else class="el-icon-plus ariza-photo-uploader__icon"></i>
                    </el-upload>
                    <p class="ariza-photo-hint">(3х4 {{ $t('dictionary.size') }})</p>
                  </el-form-item>
                </div>

                <!-- 10x15 photo -->
                <div class="ariza-photo-block">
                  <el-form-item prop="bodyPictureHashId">
                    <span class="ariza-label"><span class="ariza-label__req">*</span> {{ $t('dictionary.image') }} ({{ $t('dictionary.full_body') }})</span>
                    <el-upload
                      ref="body_picture_upload"
                      class="ariza-photo-uploader"
                      action="/nomzod/file/upload?docType=BODY_PICTURE"
                      :disabled="bodyPictureUploading"
                      :show-file-list="false"
                      :on-success="onSuccessBodyPictureUpload"
                      :before-upload="beforeBodyPictureUpload">
                      <img v-if="bodyPictureSource" :src="bodyPictureSource" class="ariza-photo-preview">
                      <i v-else class="el-icon-plus ariza-photo-uploader__icon"></i>
                    </el-upload>
                    <p class="ariza-photo-hint">(10х15 {{ $t('dictionary.size') }})</p>
                  </el-form-item>
                </div>
                </div>

              </div>
            </div>

            <!-- middle: Document uploads -->
            <div style="gap: 10px; display: grid;">
              <div class="ariza-card ariza-card--documents">

                <!-- Passport -->
                <div class="ariza-doc-section">
                  <el-form-item prop="passportHashId">
                    <span class="ariza-label"><span class="ariza-label__req">*</span> {{ $t('dictionary.passport') }}</span>
                    <el-upload
                        ref="passport_upload"
                        :on-success="onSuccessPassportUpload"
                        :before-upload="beforePassportUpload"
                        :disabled="passportUploading"
                        :show-file-list="true"
                        action="/nomzod/file/upload?docType=PASSPORT">
                      <el-button size="small" class="ariza-btn-upload ariza-btn-upload--blue">
                        <i class="el-icon-paperclip"></i> {{ $t('dictionary.upload_passport') }}
                      </el-button>
                    </el-upload>
                    <p class="ariza-doc-hint">{{ $t('dictionary.max_file_size') }}</p>
                  </el-form-item>
                </div>
              </div>
              <div class="ariza-card ariza-card--documents">
                <!-- Tarjimai hol -->
                <div class="ariza-doc-section">
                  <el-form-item prop="resumeHashId">
                    <span class="ariza-label"><span class="ariza-label__req">*</span> {{ $t('dictionary.resume') }}</span>
                    <el-upload
                        ref="resume_upload"
                        :on-success="onSuccessResumeUpload"
                        :before-upload="beforeResumeUpload"
                        :disabled="resumeUploading"
                        :show-file-list="true"
                        action="/nomzod/file/upload?docType=RESUME">
                      <el-button size="small" class="ariza-btn-upload ariza-btn-upload--blue">
                        <i class="el-icon-paperclip"></i> {{ $t('dictionary.upload_resume') }}
                      </el-button>
                    </el-upload>
                    <p class="ariza-doc-hint">{{ $t('dictionary.max_file_size') }}</p>
                    <a href="Таржимаи хол намуна.pdf" download class="ariza-btn-upload ariza-btn-upload--outline">
                      <i class="el-icon-download"></i> {{ $t('dictionary.resume_sample') }}
                    </a>
                    <p class="ariza-doc-subtitle">({{ $t('dictionary.manuscript_from') }})</p>
                  </el-form-item>
                </div>
              </div>

              <div class="ariza-card ariza-card--documents">
                <!-- Ob'ektivka -->
                <div class="ariza-doc-section">
                  <span class="ariza-label"><span class="ariza-label__req">*</span> {{ $t('dictionary.objective') }}</span>
                  <el-form-item prop="personalDataSheetHashId">
                    <el-upload
                        ref="personal_data_sheet_upload"
                        :on-success="onSuccessPersonalDataSheetUpload"
                        :before-upload="beforePersonalDataSheetUpload"
                        :disabled="personalDataSheetUploading"
                        :show-file-list="true"
                        action="/nomzod/file/upload?docType=PERSONAL_DATA_SHEET">
                      <el-button size="small" class="ariza-btn-upload ariza-btn-upload--teal">
                        <i class="el-icon-paperclip"></i> {{ $t('dictionary.upload_objective') }}
                      </el-button>
                    </el-upload>
                    <p class="ariza-doc-hint">{{ $t('dictionary.max_file_size') }}</p>
                  </el-form-item>
                  <div style="display: flex; gap: 10px;">
                    <a href="ОБЪЕКТИВКА НАМУНА.DOC" download class="ariza-btn-upload ariza-btn-upload--outline">
                      <i class="el-icon-download"></i> {{ $t('dictionary.objective_sample') }}
                    </a>
                    <a href="ОБЪЕКТИВКА ТЎЛДИРИШКА.DOC" download class="ariza-btn-upload ariza-btn-upload--outline">
                      <i class="el-icon-download"></i> {{ $t('dictionary.objective_template') }}
                    </a>
                  </div>

                </div>
              </div>

            </div>



            <!-- Right: Document uploads -->
            <div style="gap: 10px; display: grid;">
              <div class="ariza-card ariza-card--documents">

                <!-- Diplom -->
                <div class="ariza-doc-section">
                  <el-form-item prop="diplomaHashIds">
                    <span class="ariza-label"><span class="ariza-label__req">*</span> {{ $t('dictionary.diploma') }}</span>
                    <el-upload
                        ref="diploma_upload"
                        :on-success="onSuccessDiplomaUpload"
                        :before-upload="beforeDiplomaUpload"
                        :disabled="diplomaUploading"
                        :show-file-list="true"
                        action="/nomzod/file/upload?docType=DIPLOMA"
                        multiple>
                      <el-button size="small" class="ariza-btn-upload ariza-btn-upload--green">
                        <i class="el-icon-plus"></i> {{ $t('dictionary.upload_diploma') }}
                      </el-button>
                    </el-upload>
                    <p class="ariza-doc-hint">{{ $t('dictionary.max_file_size') }}</p>
                  </el-form-item>
                </div>

                <div class="ariza-doc-divider"></div>

                <!-- Diplom uklang -->
                <div class="ariza-doc-section">
                  <span class="ariza-label"><span class="ariza-label__req">*</span> {{ $t('dictionary.transcript') }}</span>
                  <el-form-item prop="transcriptHashIds" class="ariza-doc-inline">
                    <el-upload
                        ref="transcript_upload"
                        :on-success="onSuccessTranscriptUpload"
                        :before-upload="beforeTranscriptUpload"
                        :disabled="transcriptUploading"
                        :show-file-list="true"
                        action="/nomzod/file/upload?docType=TRANSCRIPT"
                        multiple>
                      <el-button size="small" class="ariza-btn-upload ariza-btn-upload--gold">
                        <i class="el-icon-plus"></i> {{ $t('dictionary.upload_transcript') }}
                      </el-button>
                    </el-upload>
                    <p class="ariza-doc-hint">{{ $t('dictionary.max_file_size') }}</p>
                  </el-form-item>
                </div>
              </div>
              <div class="ariza-card ariza-card--documents">
                <!-- Boshqa xujat uklang -->
                <div class="ariza-doc-section">
                  <span class="ariza-label"> {{ $t('dictionary.other_docs') }}</span>
                  <el-form-item class="ariza-doc-inline">
                    <el-upload
                        ref="other_upload"
                        :on-success="onSuccessOtherUpload"
                        :before-upload="beforeOtherUpload"
                        :disabled="otherUploading"
                        :show-file-list="true"
                        action="/nomzod/file/upload?docType=OTHER"
                        multiple>
                      <el-button size="small" class="ariza-btn-upload ariza-btn-upload--blue">
                        <i class="el-icon-plus"></i> {{ $t('dictionary.upload_other_docs') }}
                      </el-button>
                    </el-upload>
                    <p class="ariza-doc-hint">{{ $t('dictionary.max_file_size') }}</p>
                    <p class="ariza-doc-subtitle">({{ $t('dictionary.additional_doc_message') }})</p>
                  </el-form-item>
                </div>
                <div class="ariza-doc-divider"></div>

                <!-- Telefon raqam -->
                <div class="ariza-doc-section">
                  <el-form-item prop="regionId">
                    <span class="ariza-label"><span class="ariza-label__req"> *</span> {{ $t('dictionary.region') }}</span>
                    <el-select v-model="formData.regionId" clearable :placeholder="$t('dictionary.select_region')" style="width: 100%; margin-bottom: 10px;">
                      <el-option v-for="region in regions" :key="region.id" :label="region.address" :value="region.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="phone">
                    <span class="ariza-label"><i class="el-icon-phone-outline"></i><span class="ariza-label__req"> *</span> {{ $t('dictionary.phone') }}</span>
                    <el-input
                        type="text"
                        v-model="phoneMasked"
                        size="small"
                        maxlength="12"
                        placeholder="__ ___ __ __"
                        class="ariza-phone-input">
                      <template #prepend>+998</template>
                    </el-input>
                    <p class="ariza-doc-subtitle">({{ $t('dictionary.own_phone') }})</p>
                  </el-form-item>
                  <el-form-item>
                    <span class="ariza-label"><i class="el-icon-phone-outline"></i> {{ $t('dictionary.extra_phone') }}</span>
                    <el-input
                        type="text"
                        v-model="extraPhoneMasked"
                        size="small"
                        maxlength="12"
                        placeholder="__ ___ __ __"
                        class="ariza-phone-input">
                      <template #prepend>+998</template>
                    </el-input>
                  </el-form-item>
                </div>

                <div class="ariza-doc-divider"></div>

                <div style="display: flex; justify-content: space-between; width: 100%; margin-top: 10px;">
                  <!-- Vazni -->
                  <el-form-item prop="weight">
                    <span class="ariza-label"><span class="ariza-label__req">*</span> {{ $t('dictionary.weight') }}</span>
                    <el-input-number v-model="formData.weight" controls-position="right" size="small" :max="150"/>
                  </el-form-item>
                  <!-- Bo'yi -->
                  <el-form-item prop="height">
                    <span class="ariza-label"><span class="ariza-label__req">*</span> {{ $t('dictionary.height') }}</span>
                    <el-input-number v-model="formData.height" controls-position="right" size="small" :max="220"/>
                  </el-form-item>
                </div>

              </div>

            </div>
          </div>

        </el-form>
      </div>

      <!-- Footer -->
      <template #footer>
        <div class="ariza-dialog__footer">
          <div class="ariza-dialog__footer-left">
            <el-checkbox v-model="confirm" class="ariza-checkbox">{{ $t('dictionary.agree_with_offer') }}</el-checkbox>
            <a href="#" @click.prevent="ofertaDialogVisible = true" class="ariza-terms-link">{{ $t('dictionary.offer_view') }}</a>
          </div>
          <div class="ariza-dialog__footer-right">
            <el-button @click="dialogVisible = false" class="ariza-btn-cancel">{{ $t('dictionary.cancel') }}</el-button>
            <el-button type="primary" @click="saveRequest" :loading="panding" :disabled="!confirm" class="ariza-btn-submit">{{ $t('dictionary.confirm') }}</el-button>
          </div>
        </div>
      </template>
    </el-dialog>

    <!-- ===== Ваканциялар Modal ===== -->
    <el-dialog
      :visible.sync="vacancyDrawerVisible"
      top="3vh"
      custom-class="vd-dialog"
      :show-close="true"
      :close-on-click-modal="false">

      <template #title>
        <div class="vd-header">
          <div class="vd-header__left">
            <div class="vd-header__icon-wrap">
              <i class="el-icon-folder-opened"></i>
            </div>
            <div>
              <span class="vd-header__title">{{ $t('menu.vacancy') }}</span>
              <span class="vd-header__subtitle">{{ $t('dictionary.vacancy_list') }}</span>
            </div>
            <el-tag class="vd-header__badge" effect="dark" size="large">
            <i class="el-icon-document"></i> {{ $t('dictionary.total') }}: {{ vacancies.length }}
          </el-tag>
          </div>

        </div>
      </template>

      <div class="vd-body">
        <div class="vd-layout">
          <!-- Left: Vacancy list -->
          <div class="vd-sidebar">
            <div class="vd-sidebar__head">
              <i class="el-icon-s-order"></i> {{ $t('dictionary.vacant_positions') }}
            </div>
            <div class="vd-sidebar__scroll">
              <div class="vd-vacancy-card" v-for="(vacancy, index) in vacancies" :key="vacancy.id">
                <div class="vd-vacancy-card__number">{{ index + 1 }}</div>
                <div class="vd-vacancy-card__content">
                  <h4 class="vd-vacancy-card__title">
                    {{ getVacancyBranchByLangCode(vacancy) }}
                    <span class="vd-vacancy-card__position">{{ getVacancyPositionByLangCode(vacancy) }}</span>
                  </h4>
                  <p class="vd-vacancy-card__position">{{ $t('dictionary.vacancy_period') }}:</p>
                  <div class="vd-vacancy-card__dates">
                    <el-tag size="medium" type="success" style="font-size: 15px;">
                      <i class="el-icon-date"></i>
                      {{ moment(vacancy.startDt).format("DD.MM.YYYY") }}
                    </el-tag>
                    -
                    <el-tag size="medium" type="danger" style="font-size: 15px;">
                      <i class="el-icon-date"></i>
                      {{ moment(vacancy.endDt).format("DD.MM.YYYY") }}
                    </el-tag>
                  </div>
                  <div class="vd-vacancy-card__footer">
                    <el-tag size="medium" effect="plain" class="vd-vacancy-card__tag">
                      <i class="el-icon-user"></i> {{ vacancy.applicantCount }} {{ $t('dictionary.candidate') }}
                    </el-tag>
                    <el-button
                      type="primary"
                      size="medium"
                      class="vd-vacancy-card__btn"
                      @click="apply(vacancy.id)"
                      v-if="isLoggedIn">
                      <i class="el-icon-edit-outline"></i> {{ $t('dictionary.apply') }}
                    </el-button>
                  </div>
                </div>
                <img class="vd-vacancy-card__watermark" src="@/assets/img/logo-table.png" alt="">
              </div>
            </div>
          </div>

          <!-- Right: Tabs -->
          <div class="vd-main">
            <div class="vd-right">
              <div class="vd-right__img-wrap">
                <img :src="getImageSourceByLangCode" class="vd-tab-img" alt="Vacancy banner">
                <el-button
                  class="vd-img-zoom-btn"
                  circle
                  @click="openSamplePreview(getImageSourceByLangCode)">
                  <i class="el-icon-zoom-in"></i>
                </el-button>
              </div>
              <div class="vd-right__footer">
                <a
                  :href="getDocByLangCode"
                  download
                  class="ariza-btn-upload ariza-btn-upload--outline vd-right__download"
                >
                  <i class="el-icon-download"></i> {{ $t('dictionary.applying_rules') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        custom-class="vd-dialog_new"
        :visible.sync="ofertaDialogVisible"
        width="40%">
      <template #title>
        <div class="vd-header">
          <div class="vd-header__left">
            <div class="vd-header__icon-wrap">
              <i class="el-icon-info"></i>
            </div>
            <div>
              <span class="vd-header__title">{{ $t('dictionary.oferta_title') }}</span>
            </div>
          </div>

        </div>
      </template>
      <span>
        {{ $t('dictionary.oferta') }}
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="samplePreviewVisible"
      custom-class="sample-preview-dialog"
      width="auto"
      top="8vh"
      :show-close="true">
      <div class="sample-preview-wrap">
        <img :src="samplePreviewImage" class="sample-preview-img" alt="Preview">
      </div>
    </el-dialog>
    <el-dialog
        :title="$t('dictionary.video_tutorial')"
        :visible.sync="videoDialogVisible"
        @close="videoDialogClose"
        width="50%">
      <video v-if="videoUrl !== null" :src="videoUrl" style="width: 100%;" autoplay controls/>
    </el-dialog>
  </div>
</template>

<style scoped>
/* ══════════════════════════════════════
   Vacancy Page — Main Section
   ══════════════════════════════════════ */

/* Error notification */
.vp-error-notice {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-left: 4px solid #dc2626;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.5;
  color: #b91c1c;
  font-weight: 500;
  word-break: break-word;
  overflow-wrap: break-word;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}
.vp-error-notice i {
  font-size: 18px;
  color: #dc2626;
  flex-shrink: 0;
  margin-top: 1px;
}
.vp-error-notice span {
  flex: 1;
  min-width: 0;
}

.vp-info-notice {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #E6E6FF;
  border: 1px solid #2E2EFF;
  border-left: 4px solid #2E2EFF;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.5;
  color: #2E2EFF;
  font-weight: 500;
  word-break: break-word;
  overflow-wrap: break-word;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}
.vp-info-notice i {
  font-size: 18px;
  color: #2E2EFF;
  flex-shrink: 0;
  margin-top: 1px;
}
.vp-info-notice span {
  flex: 1;
  min-width: 0;
}

/* ── Interview report (ma'lumotnoma) ── */
.vp-report {
  background:
    linear-gradient(180deg, #fbfcfe 0%, #fff 48px),
    #fff;
  border: 1px solid #dce6f0;
  border-radius: 12px;
  margin-bottom: 20px;
  padding: 36px 48px 32px;
  box-shadow: 0 4px 24px rgba(0, 30, 80, 0.07);
  position: relative;
}
.vp-report__header {
  text-align: center;
  margin-bottom: 28px;
  padding-bottom: 22px;
  border-bottom: 1px solid #e8eef5;
}
.vp-report__title {
  margin: 0 0 14px;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 3px;
  color: #1a2a44;
  text-transform: uppercase;
}
.vp-report__subtitle {
  margin: 0 auto;
  max-width: 780px;
  font-size: 16px;
  line-height: 1.6;
  color: #4a5f73;
  font-weight: 500;
}
.vp-report__body p {
  margin: 0 0 5px;
  font-size: 17px;
  line-height: 1.85;
  color: #243447;
  text-align: justify;
  text-indent: 1.5em;
}
.vp-report__body p:last-child {
  margin-bottom: 0;
}
.vp-report__body p ::v-deep strong {
  color: #1a2a44;
  font-weight: 700;
}
.vp-report__footer {
  margin-top: 28px;
  padding-top: 18px;
  border-top: 1px solid #e8eef5;
  font-size: 17px;
  font-weight: 700;
  color: #1a2a44;
}

@media (max-width: 768px) {
  .vp-report {
    padding: 26px 18px 22px;
  }
  .vp-report__title {
    font-size: 22px;
    letter-spacing: 1.5px;
  }
  .vp-report__subtitle {
    font-size: 15px;
  }
  .vp-report__body p {
    font-size: 15.5px;
    line-height: 1.75;
    text-indent: 0;
    text-align: left;
  }
  .vp-report__footer {
    font-size: 15.5px;
  }
}

/* User auth bar */
.vp-user-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #dce6f0;
  border-radius: 12px;
  padding: 14px 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 30, 80, 0.06);
}
.vp-user-bar__info {
  display: flex;
  align-items: center;
  gap: 16px;
}
.vp-user-bar__notice {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #fff8e6;
  color: #b8860b;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 12px;
  border-radius: 6px;
  border: 1px solid #f5e6b8;
}
.vp-user-bar__notice i {
  font-size: 14px;
}
.vp-user-bar__login {
  display: flex;
  align-items: center;
  gap: 12px;
}
.vp-user-bar__login-text {
  font-size: 13px;
  color: #5a6f82;
  margin: 0;
}
.vp-btn-oneid {
  border-radius: 8px;
  font-weight: 600;
  padding: 8px 18px;
  background: linear-gradient(135deg, #27ae60, #2ecc71);
  border: none;
  color: #fff;
  transition: all 0.25s ease;
}
.vp-btn-oneid:hover {
  background: linear-gradient(135deg, #1e8c4c, #27ae60);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(39, 174, 96, 0.3);
  color: #fff;
}
.vp-user-bar__profile {
  display: flex;
  align-items: center;
  gap: 10px;
}
.vp-user-bar__avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2c5f8a, #3a7cc0);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
}
.vp-user-bar__name {
  font-size: 14px;
  font-weight: 600;
  color: #1a2a44;
}
.vp-user-bar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.vp-btn-apps {
  border-radius: 8px;
  border: 1.5px solid #3a7cc0;
  color: #3a7cc0;
  font-weight: 500;
  font-size: 12px;
  padding: 7px 14px;
  background: transparent;
  transition: all 0.25s ease;
}
.vp-btn-apps:hover {
  background: #eaf2fc;
  border-color: #2c5f8a;
  color: #2c5f8a;
}
.vp-btn-logout {
  border-radius: 8px;
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  border: none;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
  padding: 7px 14px;
  transition: all 0.25s ease;
}
.vp-btn-logout:hover {
  background: linear-gradient(135deg, #c0392b, #a93226);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);
  color: #fff;
}

/* Grid layout */
.vp-content {
  display: flex;
  gap: 15px;
  width: 100%;

}

/* Section title */
.vp-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.vp-section-title i {
  font-size: 16px;
  color: #3a7cc0;
}

/* Branch grid */
.vp-branch-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
}

/* Branch tile */
.vp-branch-tile {
  position: relative;
  background: #fff;
  border: 1px solid #dce6f0;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.vp-branch-tile:hover {
  border-color: #3a7cc0;
  box-shadow: 0 8px 28px rgba(58, 124, 192, 0.14);
  transform: translateY(-3px);
}
.vp-branch-tile__accent {
  height: 4px;
  background: linear-gradient(90deg, #2c5f8a, #3a7cc0, #5ba3d9);
}
.vp-branch-tile__body {
  padding: 16px 14px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.vp-branch-tile__icon {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: linear-gradient(135deg, #edf4fc, #dce8f5);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  transition: all 0.3s ease;
}
.vp-branch-tile:hover .vp-branch-tile__icon {
  background: linear-gradient(135deg, #2c5f8a, #3a7cc0);
}
.vp-branch-tile__icon i {
  font-size: 20px;
  color: #3a7cc0;
  transition: color 0.3s ease;
}
.vp-branch-tile:hover .vp-branch-tile__icon i {
  color: #fff;
}
.vp-branch-tile__name {
  font-size: 13px;
  font-weight: 600;
  color: #1a2a44;
  line-height: 1.35;
  margin: 0 0 10px;
  min-height: 36px;
  display: flex;
  align-items: center;
}
.vp-branch-tile__stats {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 12px;
}
.vp-branch-tile__count {
  font-size: 20px;
  font-weight: 700;
  color: #2c5f8a;
  display: flex;
  align-items: center;
  gap: 4px;
}
.vp-branch-tile__count i {
  font-size: 14px;
  color: #3a7cc0;
}
.vp-branch-tile__label {
  font-size: 11px;
  color: #8a9db0;
  font-weight: 500;
}
.vp-branch-tile__btn {
  width: 100%;
  border-radius: 8px;
  font-weight: 600;
  font-size: 12px;
  padding: 7px 0;
  background: linear-gradient(135deg, #2980b9, #3498db);
  border: none;
  transition: all 0.25s ease;
  letter-spacing: 0.3px;
}
.vp-branch-tile:hover .vp-branch-tile__btn {
  background: linear-gradient(135deg, #1c6ea1, #2980b9);
  box-shadow: 0 3px 10px rgba(41, 128, 185, 0.3);
}

/* Statistics card */
.vp-stats-card {
  background: #fff;
  border: 1px solid #dce6f0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 30, 80, 0.05);
}
.vp-table {
  width: 100%;
  border-collapse: collapse;
}
.vp-table thead tr {
  background: linear-gradient(135deg, #1a2a44, #2c4a6e);
}
.vp-table thead th {
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 10px 14px;
  text-align: left;
  border: none;
  letter-spacing: 0.3px;
}
.vp-table thead th:not(:first-child) {
  text-align: center;
}
.vp-table tbody td {
  font-size: 12px;
  color: #2c3e50;
  padding: 9px 14px;
  border-bottom: 1px solid #edf2f8;
  border-left: none;
  border-right: none;
  border-top: none;
}
.vp-table__center {
  text-align: center;
}
.vp-table tbody tr:hover {
  background: #f5f9fd;
}
.vp-table__total {
  background: linear-gradient(90deg, #edf2f8, #f6f9fc);
}
.vp-table__total td {
  font-weight: 700;
  color: #1a2a44;
  font-size: 13px;
  border-bottom: none;
}

/* ── Legacy table styles (page-wide) ── */
table, tr, td, th {
  border: 1px solid #ddd;
  border-collapse: collapse;
}
td, th {
  padding: 5px 10px;
  text-align: left;
  font-size: 14px;
}
thead td { font-weight: 500; }
thead th { text-align: center; }

/* ══════════════════════════════════════
   Ваканциялар — Modal Design System
   ══════════════════════════════════════ */

/* Dialog container */
::v-deep .vd-dialog {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 30, 80, 0.22), 0 4px 16px rgba(0, 0, 0, 0.08);
  margin-top: 6vh !important;
  height: calc(90vh - 50px);
  width: 80vw;
}
::v-deep .vd-dialog .el-dialog__header {
  background: linear-gradient(135deg, #1a2a44 0%, #2c4a6e 50%, #3a6a9e 100%);
  padding: 0 !important;
  margin: 0;
}
::v-deep .vd-dialog .el-dialog__headerbtn .el-dialog__close {
  color: rgba(255, 255, 255, 0.75);
  font-size: 20px;
  font-weight: 600;
}
::v-deep .vd-dialog .el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}
::v-deep .vd-dialog .el-dialog__body {
  padding: 0 !important;
}
::v-deep .vd-dialog .el-dialog__footer {
  display: none;
}

::v-deep .vd-dialog_new {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 30, 80, 0.22), 0 4px 16px rgba(0, 0, 0, 0.08);
  margin-top: 20vh !important;
}
::v-deep .vd-dialog_new .el-dialog__header {
  background: linear-gradient(135deg, #1a2a44 0%, #2c4a6e 50%, #3a6a9e 100%);
  padding: 0 !important;
  margin: 0;
}
::v-deep .vd-dialog_new .el-dialog__headerbtn .el-dialog__close {
  color: rgba(255, 255, 255, 0.75);
  font-size: 20px;
  font-weight: 600;
}
::v-deep .vd-dialog_new .el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}
::v-deep .vd-dialog_new .el-dialog__body {
  font-size: 16px;
  padding: 16px;
  margin: 15px 20px;
  text-align: justify;
  word-break: break-word;
}
::v-deep .vd-dialog_new .el-dialog__footer {
  display: none;
}


/* Header */
.vd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  width: 100%;
}
.vd-header__left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.vd-header__icon-wrap {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
}
.vd-header__title {
  display: block;
  font-size: 17px;
  text-transform: uppercase;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.4px;
  line-height: 1.2;
}
.vd-header__subtitle {
  display: block;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  font-weight: 300;
  letter-spacing: 0.3px;
}
.vd-header__badge {
  background: rgba(255, 255, 255, 0.14) !important;
  border: 1px solid rgba(255, 255, 255, 0.22) !important;
  color: #fff !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  margin-left: 10px;
  border-radius: 8px !important;
  font-size: 17px;
  display: inline-table;
  text-transform: uppercase;
  padding: 4px 15px !important;
}

/* Body */
.vd-body {
  height: calc(90vh - 116px);
  overflow-y: auto;
  overflow-x: hidden;
}
.vd-layout {
  display: flex;
  min-height: 100%;
}

/* Sidebar — Vacancy list */
.vd-sidebar {
  width: 450px;
  background: linear-gradient(180deg, #edf2f8 0%, #f6f8fb 100%);
  border-right: 1px solid #d4dfe9;
  display: flex;
  flex-direction: column;
}
.vd-sidebar__head {
  padding: 12px 16px;
  font-size: 15px;
  text-transform: uppercase;
  font-weight: 600;
  color: #3c5570;
  background: rgba(58, 124, 192, 0.06);
  border-bottom: 1px solid #dce8f2;
  display: flex;
  align-items: center;
  gap: 6px;
}
.vd-sidebar__head i {
  font-size: 15px;
  color: #3a7cc0;
}
.vd-sidebar__scroll {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}
.vd-sidebar__scroll::-webkit-scrollbar {
  width: 4px;
}
.vd-sidebar__scroll::-webkit-scrollbar-thumb {
  background: #b8cce0;
  border-radius: 4px;
}

/* Vacancy card */
.vd-vacancy-card {
  position: relative;
  background: #fff;
  border: 1px solid #dce6f0;
  border-radius: 12px;
  padding: 14px 14px 12px 46px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: default;
}
.vd-vacancy-card:hover {
  border-color: #3a7cc0;
  box-shadow: 0 6px 20px rgba(58, 124, 192, 0.12);
  transform: translateY(-2px);
}
.vd-vacancy-card__number {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 36px;
  background: linear-gradient(180deg, #2c5f8a, #3a7cc0);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px 0 0 12px;
}
.vd-vacancy-card__content {
  position: relative;
  z-index: 1;
}
.vd-vacancy-card__title {
  display: grid;
  font-size: 15px;
  font-weight: 600;
  color: #1a2a44;
  margin: 0 0 6px;
  line-height: 1.4;
}
.vd-vacancy-card__position {
  font-weight: 400;
  color: #5a7a96;
  font-size: 15px;
}
.vd-vacancy-card__dates {
  display: flex;
  gap: 14px;
  margin-bottom: 15px;
}
.vd-vacancy-card__date {
  font-size: 15px;
  color: #6b8ba8;
  display: flex;
  align-items: center;
  gap: 3px;
}
.vd-vacancy-card__date i {
  font-size: 15px;
  color: #3a7cc0;
}
.vd-vacancy-card__date--end i {
  color: #e67e22;
}
.vd-vacancy-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}
.vd-vacancy-card__tag {
  font-size: 15px;
  border-color: #d4e4f0 !important;
  color: #4a6a88 !important;
}
.vd-vacancy-card__btn {
  border-radius: 8px;
  font-weight: 500;
  font-size: 15px;
  padding: 7px 15px;
  background: linear-gradient(135deg, #2980b9, #3498db);
  border: none;
  transition: all 0.25s ease;
}
.vd-vacancy-card__btn:hover {
  background: linear-gradient(135deg, #1c6ea1, #2980b9);
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(41, 128, 185, 0.3);
}
.vd-vacancy-card__watermark {
  position: absolute;
  width: 60px;
  opacity: 0.05;
  right: 10px;
  bottom: 8px;
  pointer-events: none;
}

/* Main area — Tabs */
.vd-main {
  flex: 1;
  overflow: hidden;
  padding: 14px 18px;
  background: #fff;
  min-width: 0;
}
.vd-right {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0; /* allow image wrapper to shrink and keep footer visible */
}
.vd-right__img-wrap {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #fff;
  position: relative;
}

/* Zoom button on vacancy image */
.vd-img-zoom-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 3;
  border: none !important;
  color: #fff !important;
  background: linear-gradient(135deg, rgba(44, 95, 138, 0.88), rgba(58, 124, 192, 0.88)) !important;
  box-shadow: 0 4px 16px rgba(26, 42, 68, 0.3);
  width: 38px !important;
  height: 38px !important;
  font-size: 18px;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  transition: all 0.25s ease;
  cursor: pointer;
}
.vd-img-zoom-btn:hover {
  background: linear-gradient(135deg, rgba(52, 152, 219, 0.95), rgba(28, 110, 161, 0.95)) !important;
  transform: scale(1.08);
  box-shadow: 0 6px 20px rgba(41, 128, 185, 0.4);
}
.vd-img-zoom-btn:active {
  transform: scale(0.95);
}
.vd-img-zoom-btn i {
  font-size: 18px;
  line-height: 1;
}
.vd-right__footer {
  flex: 0 0 auto;
  text-align: center;
  margin-top: 16px;
}
.vd-right__download {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
::v-deep .vd-tabs .el-tabs__header {
  margin-bottom: 12px;
}
::v-deep .vd-tabs .el-tabs__nav-wrap::after {
  background: #e0eaf2;
}
::v-deep .vd-tabs .el-tabs__item {
  font-size: 13px;
  font-weight: 500;
  color: #6b8ba8;
  padding: 0 16px;
  height: 36px;
  line-height: 36px;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}
::v-deep .vd-tabs .el-tabs__item.is-top.is-active {
  background-color: #394869 !important;
  color: #fff !important;
  border-radius: 8px !important;
  border: 0 !important;
}
::v-deep .vd-tabs .el-tabs__item.is-active {
  color: #1a2a44;
  font-weight: 600;
}
::v-deep .vd-tabs .el-tabs__active-bar {
  background: linear-gradient(90deg, #2c5f8a, #3a7cc0);
  height: 3px;
  border-radius: 3px;
}
.vd-tab-content {
  overflow-y: auto;
  height: calc(90vh - 242px);
  border-radius: 8px;
  border: 1px solid #e8eef4;
  background: #fafbfc;
  padding: 8px;
}
.vd-tab-content::-webkit-scrollbar {
  width: 5px;
}
.vd-tab-content::-webkit-scrollbar-thumb {
  background: #c0d0e0;
  border-radius: 4px;
}
.vd-tab-img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  object-fit: contain;
  object-position: top center;
  display: block;
}

/* Legacy box class (kept for compatibility) */
.box {
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
}

/* ══════════════════════════════════════
   Ариза яратиш — Modal Design System
   ══════════════════════════════════════ */

/* Dialog container */
::v-deep .ariza-dialog {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 57, 124, 0.22), 0 4px 16px rgba(0, 0, 0, 0.08);
}

/* Header */
::v-deep .ariza-dialog .el-dialog__header {
  /* background: linear-gradient(135deg, #1a3a5c 0%, #2c5f8a 40%, #3a7cc0 100%); */
  background: #394869;
  padding: 0 !important;
  margin: 0;
}
::v-deep .ariza-dialog .el-dialog__headerbtn .el-dialog__close {
  color: rgba(255, 255, 255, 0.85);
  font-size: 20px;
  font-weight: 600;
}
::v-deep .ariza-dialog .el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}
.ariza-dialog__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 24px;
  color: #fff;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.3px;
}
.ariza-dialog__header-icon {
  font-size: 20px;
  opacity: 0.85;
}

/* Body */
::v-deep .ariza-dialog .el-dialog__body {
  padding: 0 !important;
}
.ariza-dialog__body {
  background: linear-gradient(180deg, #e8f0f8 0%, #f0f5fa 100%);
  padding: 22px 24px 16px;
}

/* Card base */
.ariza-card {
  background: #ffffff;
  border: 1px solid #d0dde9;
  border-radius: 10px;
  padding: 18px;
  transition: box-shadow 0.25s ease;
}
.ariza-card:hover {
  box-shadow: 0 4px 20px rgba(0, 57, 124, 0.08);
}

/* ── Top grid: Photos | Documents ── */
.ariza-grid-top {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 18px;
  margin-bottom: 18px;
}

/* Photos card */
.ariza-card--photos {
  padding: 16px 12px;
}
.ariza-photos-row {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
}

/* Individual photo block */
.ariza-photo-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 140px;
}
.ariza-photo-block--sample {
  text-align: center;
  width: 100%;
}

/* Photo uploader */
.ariza-photo-uploader {
  border: 2px dashed #b8cfe0;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 130px;
  height: 150px;
  text-align: center;
  background: #f5f9fd;
  transition: all 0.3s ease;
}
.ariza-photo-uploader:hover {
  border-color: #3a7cc0;
  background: #eaf2fc;
}
.ariza-photo-uploader__icon {
  font-size: 32px;
  color: #a0b8d0;
  width: 130px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.ariza-photo-preview {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: cover;
}
.ariza-photo-hint {
  font-size: 12px;
  color: #7a8fa3;
  text-align: center;
  margin-top: 6px;
  font-style: italic;
}

/* Sample images */
.ariza-sample-images {
  display: flex;
  gap: 6px;
  margin-top: 10px;
  border: 2px solid #c2d5e5;
  border-radius: 8px;
  padding: 6px;
  background: #f8fbfd;
}
.ariza-sample-item {
  position: relative;
  overflow: hidden;
  border-radius: 6px;
}
.ariza-sample-img {
  width: 160px;
  height: auto;
  border-radius: 4px;
  object-fit: cover;
  transition: transform 0.25s ease;
}
.ariza-sample-item:hover .ariza-sample-img {
  transform: scale(1.04);
}
.ariza-sample-zoom-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  border: none;
  color: #ffffff;
  background: linear-gradient(135deg, rgba(58, 124, 192, 0.95), rgba(26, 42, 68, 0.95));
  box-shadow: 0 4px 12px rgba(26, 42, 68, 0.28);
  opacity: 1;
  transform: translateY(0);
  transition: all 0.2s ease;
}
.ariza-sample-zoom-btn:hover {
  background: linear-gradient(135deg, rgba(52, 152, 219, 0.98), rgba(28, 110, 161, 0.98));
}
.ariza-photo-uploads-row {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 15px;
  width: 100%;
}
.sample-preview-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
}
.sample-preview-img {
  max-width: 100%;
  max-height: 74vh;
  border-radius: 10px;
  box-shadow: 0 16px 36px rgba(20, 30, 50, 0.22);
}
.ariza-sample-caption {
  font-size: 11px;
  color: #8a9db0;
  text-align: center;
  margin-top: 6px;
}
::v-deep .sample-preview-dialog .el-dialog__body {
  padding: 0;
}
::v-deep .sample-preview-dialog.el-dialog {
  width: fit-content !important;
  max-width: 92vw;
  border-radius: 12px;
  overflow: hidden;
}
::v-deep .sample-preview-dialog .el-dialog__header {
  padding: 0;
  margin: 0;
  min-height: 0;
}
::v-deep .sample-preview-dialog .el-dialog__headerbtn {
  top: 8px;
  right: 10px;
  z-index: 4;
  background: rgba(20, 30, 50, 0.62);
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .sample-preview-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-weight: 700;
}

/* Documents card (right sidebar) */
.ariza-card--documents {
  padding: 0px 15px;
  border-left: 4px solid #3a7cc0;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.ariza-doc-section {
  padding: 10px 0;
}
.ariza-doc-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, #d0dde9, transparent);
}
.ariza-doc-hint {
  font-size: 11px;
  color: #8a9db0;
  margin: 2px 0 6px;
}
.ariza-doc-subtitle {
  font-size: 12px;
  color: #c0392b;
  font-weight: 500;
  margin-bottom: 6px;
}
.ariza-doc-inline {
  margin-bottom: 0;
}

/* Labels */
.ariza-label {
  display: block;
  font-size: 15px;
  margin-bottom: 5px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
}
.ariza-label__req {
  color: #e74c3c;
  margin-right: 2px;
  font-weight: 700;
}

::v-deep label {
  margin-bottom: 0px;
}

/* ── Bottom grid ── */
.ariza-grid-bottom {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1.3fr;
  gap: 14px;
}
.ariza-card--input,
.ariza-card--objektivka,
.ariza-card--phone {
  padding: 14px;
}

/* ── Upload buttons ── */
.ariza-btn-upload {
  border-radius: 8px;
  font-weight: 500;
  font-size: 13px;
  padding: 9px 18px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.25s ease;
  border: none;
  letter-spacing: 0.2px;
}

/* Blue (Passport) */
.ariza-btn-upload--blue {
  background: linear-gradient(135deg, #2980b9, #3498db);
  color: #fff;
}
.ariza-btn-upload--blue:hover {
  background: linear-gradient(135deg, #1c6ea1, #2980b9);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(41, 128, 185, 0.35);
  color: #fff;
}

/* Green (Weight/Height/Diploma) */
.ariza-btn-upload--green {
  background: linear-gradient(135deg, #27ae60, #2ecc71);
  color: #fff;
}
.ariza-btn-upload--green:hover {
  background: linear-gradient(135deg, #1e8c4c, #27ae60);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(39, 174, 96, 0.35);
  color: #fff;
}

/* Gold (Diploma ilova) */
.ariza-btn-upload--gold {
  background: linear-gradient(135deg, #d4a017, #f1c40f);
  color: #fff;
}
.ariza-btn-upload--gold:hover {
  background: linear-gradient(135deg, #b8860b, #d4a017);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(212, 160, 23, 0.35);
  color: #fff;
}

/* Teal (Objektivka) */
.ariza-btn-upload--teal {
  background: linear-gradient(135deg, #16a085, #1abc9c);
  color: #fff;
}
.ariza-btn-upload--teal:hover {
  background: linear-gradient(135deg, #0e7c67, #16a085);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(22, 160, 133, 0.35);
  color: #fff;
}

/* Outline (Tarjimai hol) */
.ariza-btn-upload--outline {
  background: transparent;
  display: inline-flex;
  align-items: center;
  color: #3a7cc0;
  font-weight: 500;
  font-size: 13px;
  padding: 5px 10px;
  transition: all 0.25s ease;
  border: 1.5px solid #3a7cc0;
}
.ariza-btn-upload--outline:hover {
  background: #eaf2fc;
  color: #2c5f8a;
  border-color: #2c5f8a;
}

/* ── Phone input with +998 prepend ── */
::v-deep .ariza-phone-input .el-input-group__prepend {
  background: linear-gradient(135deg, #2c5f8a, #3a7cc0);
  color: #fff;
  border: none;
  font-weight: 600;
  font-size: 14px;
  padding: 0 14px;
  border-radius: 8px 0 0 8px;
  letter-spacing: 0.5px;
}
::v-deep .ariza-phone-input .el-input__inner {
  border-radius: 0 8px 8px 0;
  border: 1.5px solid #d0dde9;
  border-left: none;
  padding: 8px 14px;
  font-size: 14px;
  letter-spacing: 1px;
  transition: border-color 0.3s ease;
}
::v-deep .ariza-phone-input .el-input__inner:focus {
  border-color: #3a7cc0;
  box-shadow: 0 0 0 3px rgba(58, 124, 192, 0.12);
}

/* ── Footer ── */
::v-deep .ariza-dialog .el-dialog__footer {
  border-top: 1px solid #e0eaf2;
  padding: 14px 24px !important;
  background: #f9fbfd;
}
.ariza-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ariza-dialog__footer-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ariza-dialog__footer-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Checkbox */
::v-deep .ariza-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #3a7cc0;
  border-color: #3a7cc0;
}
::v-deep .ariza-checkbox .el-checkbox__label {
  font-size: 15px;
  color: #3c4f63;
}

/* Terms link */
.ariza-terms-link {
  font-size: 15px;
  color: #3a7cc0;
  text-decoration: none;
  transition: color 0.2s ease;
}
.ariza-terms-link:hover {
  color: #1a3a5c;
  text-decoration: underline;
}

/* Cancel button */
.ariza-btn-cancel {
  border-radius: 8px;
  border: 1.5px solid #c0cdd9;
  color: #5a6f82;
  font-weight: 500;
  padding: 9px 24px;
  transition: all 0.25s ease;
}
.ariza-btn-cancel:hover {
  border-color: #8a9db0;
  color: #3c4f63;
  background: #f0f5fa;
}

/* Submit button */
.ariza-btn-submit {
  border-radius: 8px;
  background: linear-gradient(135deg, #2980b9, #3498db);
  border: none;
  color: #fff;
  font-weight: 600;
  padding: 9px 28px;
  letter-spacing: 0.3px;
  transition: all 0.25s ease;
}
.ariza-btn-submit:hover {
  background: linear-gradient(135deg, #1c6ea1, #2980b9);
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(41, 128, 185, 0.35);
}
.ariza-btn-submit:disabled {
  background: #b0c4d8;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* ── Form item overrides inside ariza ── */
::v-deep .ariza-dialog .el-form-item {
  margin-bottom: 8px;
}
::v-deep .ariza-dialog .el-form-item__label {
  padding-bottom: 4px !important;
  line-height: 1.4;
  float: none;
  display: block;
  text-align: left;
}
::v-deep .ariza-dialog .el-form-item__content {
  margin-left: 0 !important;
  line-height: 1.6;
}

/* ══════════════════════════════════════════════════════════
   RESPONSIVE — TABLET (≤1024px)
   ══════════════════════════════════════════════════════════ */
@media (max-width: 1024px) {

  /* ── Main page layout ── */
  .vp-content {
    flex-direction: column;
  }
  .vp-branch-grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 12px;
  }

  /* ── User bar: stack on tablet ── */
  .vp-user-bar {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
    padding: 12px 16px;
  }
  .vp-user-bar__info {
    justify-content: center;
  }
  .vp-user-bar > div[style] {
    justify-content: center !important;
    flex-wrap: wrap;
    gap: 8px;
  }

  /* ── Ariza dialog ── */
  ::v-deep .ariza-dialog {
    width: 92vw !important;
    margin: 4vh auto !important;
  }
  .ariza-grid-top {
    grid-template-columns: 1fr 1fr;
    gap: 14px;
  }
  .ariza-dialog__body {
    padding: 16px;
  }

  /* ── Vacancy dialog ── */
  ::v-deep .vd-dialog {
    width: 92vw !important;
  }
  .vd-sidebar {
    width: 340px;
  }

  /* ── Oferta dialog ── */
  ::v-deep .vd-dialog_new {
    width: 60% !important;
  }

  /* ── Video dialog ── */
  ::v-deep .el-dialog[aria-label] {
    width: 70% !important;
  }
}

/* ══════════════════════════════════════════════════════════
   RESPONSIVE — SMALL TABLET / LARGE PHONE (≤768px)
   ══════════════════════════════════════════════════════════ */
@media (max-width: 768px) {

  /* ── Main page ── */
  .vp-content {
    flex-direction: column;
    gap: 12px;
  }
  .vp-branch-grid {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 10px;
  }
  .vp-branch-tile__body {
    padding: 12px 10px 10px;
  }
  .vp-branch-tile__name {
    font-size: 12px;
    min-height: 32px;
  }
  .vp-branch-tile__count {
    font-size: 17px;
  }
  .vp-branch-tile__icon {
    width: 36px;
    height: 36px;
  }
  .vp-branch-tile__icon i {
    font-size: 17px;
  }
  .vp-section-title {
    font-size: 13px;
    margin-bottom: 10px;
  }

  /* ── User bar ── */
  .vp-user-bar {
    flex-direction: column;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 10px;
  }
  .vp-user-bar__info {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
  }
  .vp-user-bar__login {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  .vp-user-bar__login-text {
    text-align: center;
    font-size: 12px;
  }
  .vp-user-bar > div[style] {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 6px !important;
  }
  .vp-user-bar__actions {
    flex-direction: column;
    gap: 6px !important;
    margin-left: 0 !important;
  }
  .vp-btn-apps,
  .vp-btn-logout {
    width: 100%;
    text-align: center;
    justify-content: center;
  }

  /* ── Stats table ── */
  .vp-stats-card {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .vp-table {
    min-width: 420px;
  }

  /* ── Ariza dialog (application form) ── */
  ::v-deep .ariza-dialog {
    width: 96vw !important;
    margin: 2vh auto !important;
    border-radius: 12px;
  }
  .ariza-grid-top {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .ariza-dialog__body {
    padding: 12px;
  }
  .ariza-dialog__header {
    padding: 12px 16px;
    font-size: 15px;
  }
  .ariza-photos-row {
    gap: 12px;
  }
  .ariza-photo-uploads-row {
    flex-direction: row;
    justify-content: center;
    gap: 10px;
  }
  .ariza-photo-uploader {
    width: 110px;
    height: 130px;
  }
  .ariza-photo-uploader__icon {
    width: 110px;
    height: 130px;
    line-height: 130px;
    font-size: 28px;
  }
  .ariza-sample-img {
    width: 120px;
  }
  .ariza-card {
    padding: 14px;
  }
  .ariza-card--documents {
    padding: 0 12px;
  }
  .ariza-label {
    font-size: 13px;
  }
  .ariza-btn-upload {
    font-size: 12px;
    padding: 8px 14px;
  }
  .ariza-doc-section div[style*="display: flex"] {
    flex-direction: column;
    gap: 8px !important;
  }

  /* Footer stacking */
  .ariza-dialog__footer {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  .ariza-dialog__footer-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
  .ariza-dialog__footer-right {
    justify-content: stretch;
  }
  .ariza-dialog__footer-right .el-button {
    flex: 1;
  }
  ::v-deep .ariza-dialog .el-dialog__footer {
    padding: 12px 16px !important;
  }

  /* Weight/height row */
  .ariza-dialog__body div[style*="display: flex"][style*="justify-content: space-between"] {
    flex-direction: column;
    gap: 8px;
  }

  /* ── Vacancy dialog ── */
  ::v-deep .vd-dialog {
    width: 96vw !important;
    height: calc(94vh - 20px);
    margin-top: 3vh !important;
    border-radius: 12px;
  }
  .vd-layout {
    flex-direction: column;
  }
  .vd-sidebar {
    width: 100%;
    max-height: 50vh;
    border-right: none;
    border-bottom: 1px solid #d4dfe9;
  }
  .vd-sidebar__scroll {
    padding: 10px;
  }
  .vd-main {
    padding: 10px 12px;
  }
  .vd-body {
    height: calc(94vh - 100px);
  }
  .vd-header {
    padding: 12px 16px;
  }
  .vd-header__title {
    font-size: 14px;
  }
  .vd-header__badge {
    font-size: 13px;
    padding: 3px 10px !important;
    margin-left: 6px;
  }
  .vd-vacancy-card {
    padding: 12px 12px 10px 42px;
  }
  .vd-vacancy-card__title {
    font-size: 13px;
  }
  .vd-vacancy-card__position {
    font-size: 13px;
  }
  .vd-vacancy-card__dates {
    gap: 8px;
    margin-bottom: 10px;
    flex-wrap: wrap;
  }
  .vd-vacancy-card__footer {
    flex-wrap: wrap;
    gap: 8px;
  }

  /* Right panel — image + download (tablet) */
  .vd-right {
    height: auto;
  }
  .vd-right__img-wrap {
    flex: 0 0 auto;
    height: auto;
    min-height: auto;
    overflow: visible;
    align-items: flex-start;
  }
  .vd-tab-img {
    height: auto;
    width: 100%;
    object-fit: contain;
    object-position: top center;
  }
  .vd-right__footer {
    margin-top: 10px;
  }
  .vd-img-zoom-btn {
    top: 10px;
    right: 10px;
    width: 34px !important;
    height: 34px !important;
    font-size: 16px;
  }
  .vd-img-zoom-btn i {
    font-size: 16px;
  }

  /* ── Oferta dialog ── */
  ::v-deep .vd-dialog_new {
    width: 90% !important;
    margin-top: 10vh !important;
  }
  ::v-deep .vd-dialog_new .el-dialog__body {
    font-size: 14px;
    padding: 12px;
    margin: 10px 12px;
  }

  /* ── Video dialog ── */
  ::v-deep .el-dialog:not(.ariza-dialog):not(.vd-dialog):not(.vd-dialog_new):not(.sample-preview-dialog) {
    width: 92% !important;
  }

  /* ── Sample preview ── */
  .sample-preview-img {
    max-height: 65vh;
  }
  ::v-deep .sample-preview-dialog.el-dialog {
    max-width: 96vw;
  }
}

/* ══════════════════════════════════════════════════════════
   RESPONSIVE — MOBILE PHONE (≤480px)
   ══════════════════════════════════════════════════════════ */
@media (max-width: 480px) {

  /* ── Main page ── */
  .vp-branch-grid {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
  .vp-branch-tile__body {
    padding: 10px 8px 8px;
  }
  .vp-branch-tile__name {
    font-size: 11px;
    min-height: 28px;
  }
  .vp-branch-tile__count {
    font-size: 15px;
  }
  .vp-branch-tile__icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    margin-bottom: 6px;
  }
  .vp-branch-tile__icon i {
    font-size: 15px;
  }
  .vp-branch-tile__stats {
    margin-bottom: 8px;
  }
  .vp-branch-tile__btn {
    font-size: 11px;
    padding: 5px 0;
  }
  .vp-branch-tile__label {
    font-size: 10px;
  }
  .vp-branch-tile__accent {
    height: 3px;
  }
  .vp-section-title {
    font-size: 12px;
    margin-bottom: 8px;
  }
  .vp-section-title i {
    font-size: 14px;
  }

  /* ── Error notice ── */
  .vp-error-notice {
    font-size: 12px;
    padding: 10px 12px;
    margin-bottom: 12px;
    border-radius: 6px;
    gap: 6px;
    border-left-width: 3px;
  }
  .vp-error-notice i {
    font-size: 15px;
  }

  /* ── User bar ── */
  .vp-user-bar {
    padding: 8px 10px;
    margin-bottom: 12px;
    border-radius: 8px;
  }
  .vp-user-bar__name {
    font-size: 13px;
  }
  .vp-user-bar__avatar {
    width: 30px;
    height: 30px;
    font-size: 14px;
  }
  .vp-btn-oneid {
    width: 100%;
    justify-content: center;
    padding: 10px 18px;
  }
  .vp-btn-apps,
  .vp-btn-logout {
    font-size: 12px;
    padding: 8px 12px;
  }

  /* ── Stats table ── */
  .vp-table thead th {
    font-size: 11px;
    padding: 8px 10px;
  }
  .vp-table tbody td {
    font-size: 11px;
    padding: 7px 10px;
  }
  .vp-table__total td {
    font-size: 12px;
  }

  /* ── Error message ── */
  .section p[style*="color: red"] {
    font-size: 12px;
  }

  /* ── Ariza dialog (application form) ── */
  ::v-deep .ariza-dialog {
    width: 98vw !important;
    margin: 1vh auto !important;
    border-radius: 10px;
  }
  .ariza-dialog__body {
    padding: 8px;
  }
  .ariza-dialog__header {
    padding: 10px 14px;
    font-size: 14px;
    gap: 8px;
  }
  .ariza-dialog__header-icon {
    font-size: 17px;
  }
  .ariza-grid-top {
    gap: 8px;
    margin-bottom: 10px;
  }
  .ariza-card {
    padding: 10px;
    border-radius: 8px;
  }
  .ariza-card--documents {
    padding: 0 10px;
    border-left-width: 3px;
  }
  .ariza-card--photos {
    padding: 10px 8px;
  }

  /* Photo uploads */
  .ariza-photo-uploads-row {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
  .ariza-photo-uploader {
    width: 100px;
    height: 120px;
  }
  .ariza-photo-uploader__icon {
    width: 100px;
    height: 120px;
    line-height: 120px;
    font-size: 26px;
  }
  .ariza-photo-block {
    min-width: 100px;
  }
  .ariza-photo-hint {
    font-size: 11px;
  }

  /* Sample images */
  .ariza-sample-images {
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 8px;
  }
  .ariza-sample-img {
    width: 100%;
    max-width: 200px;
  }
  .ariza-sample-caption {
    font-size: 10px;
  }

  /* Labels & buttons */
  .ariza-label {
    font-size: 12px;
    margin-bottom: 4px;
  }
  .ariza-btn-upload {
    font-size: 11px;
    padding: 7px 12px;
    border-radius: 6px;
  }
  .ariza-btn-upload--outline {
    font-size: 11px;
    padding: 4px 8px;
  }
  .ariza-doc-hint {
    font-size: 10px;
  }
  .ariza-doc-subtitle {
    font-size: 11px;
  }

  /* Phone input */
  ::v-deep .ariza-phone-input .el-input-group__prepend {
    font-size: 12px;
    padding: 0 10px;
  }
  ::v-deep .ariza-phone-input .el-input__inner {
    font-size: 13px;
    padding: 7px 10px;
  }

  /* Input number */
  ::v-deep .el-input-number--small {
    width: 100% !important;
  }

  /* Footer */
  .ariza-dialog__footer {
    gap: 10px;
  }
  .ariza-dialog__footer-left {
    gap: 4px;
  }
  ::v-deep .ariza-checkbox .el-checkbox__label {
    font-size: 12px;
  }
  .ariza-terms-link {
    font-size: 12px;
  }
  .ariza-btn-cancel,
  .ariza-btn-submit {
    padding: 8px 16px;
    font-size: 13px;
  }
  ::v-deep .ariza-dialog .el-dialog__footer {
    padding: 10px 12px !important;
  }

  /* ── Vacancy dialog ── */
  ::v-deep .vd-dialog {
    width: 100vw !important;
    height: 100vh;
    margin-top: 0 !important;
    border-radius: 0;
  }
  .vd-body {
    height: calc(100vh - 72px);
  }
  .vd-sidebar {
    max-height: 45vh;
  }
  .vd-sidebar__head {
    padding: 10px 12px;
    font-size: 12px;
  }
  .vd-sidebar__scroll {
    padding: 8px;
  }
  .vd-main {
    padding: 8px 10px;
  }
  .vd-header {
    padding: 10px 14px;
    flex-wrap: wrap;
    gap: 8px;
  }
  .vd-header__left {
    gap: 8px;
    flex-wrap: wrap;
  }
  .vd-header__icon-wrap {
    width: 32px;
    height: 32px;
    font-size: 15px;
    border-radius: 8px;
  }
  .vd-header__title {
    font-size: 13px;
  }
  .vd-header__subtitle {
    font-size: 11px;
  }
  .vd-header__badge {
    font-size: 11px;
    padding: 2px 8px !important;
    margin-left: 0;
  }

  /* Vacancy cards */
  .vd-vacancy-card {
    padding: 10px 10px 8px 36px;
    margin-bottom: 8px;
    border-radius: 10px;
  }
  .vd-vacancy-card__number {
    width: 28px;
    font-size: 12px;
    border-radius: 10px 0 0 10px;
  }
  .vd-vacancy-card__title {
    font-size: 12px;
    margin-bottom: 4px;
  }
  .vd-vacancy-card__position {
    font-size: 12px;
  }
  .vd-vacancy-card__dates {
    gap: 6px;
    margin-bottom: 8px;
  }
  .vd-vacancy-card__dates .el-tag {
    font-size: 12px !important;
  }
  .vd-vacancy-card__footer {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
  }
  .vd-vacancy-card__tag {
    font-size: 12px;
    text-align: center;
  }
  .vd-vacancy-card__btn {
    font-size: 12px;
    width: 100%;
    text-align: center;
    padding: 6px 10px;
  }
  .vd-vacancy-card__watermark {
    width: 40px;
  }

  /* Right panel — image + download */
  .vd-right {
    height: auto;
  }
  .vd-right__img-wrap {
    flex: 0 0 auto;
    height: auto;
    min-height: auto;
    overflow: visible;
    align-items: flex-start;
  }
  .vd-tab-img {
    height: auto;
    width: 100%;
    object-fit: contain;
    object-position: top center;
    border-radius: 4px;
  }
  .vd-right__footer {
    margin-top: 8px;
  }
  .vd-right__download {
    font-size: 12px;
    padding: 6px 12px;
    width: 100%;
    justify-content: center;
  }
  .vd-img-zoom-btn {
    top: 8px;
    right: 8px;
    width: 32px !important;
    height: 32px !important;
    font-size: 15px;
  }
  .vd-img-zoom-btn i {
    font-size: 15px;
  }

  /* ── Oferta dialog ── */
  ::v-deep .vd-dialog_new {
    width: 96% !important;
    margin-top: 5vh !important;
    border-radius: 10px;
  }
  ::v-deep .vd-dialog_new .el-dialog__body {
    font-size: 13px;
    padding: 10px;
    margin: 8px 10px;
  }

  /* ── Video dialog ── */
  ::v-deep .el-dialog:not(.ariza-dialog):not(.vd-dialog):not(.vd-dialog_new):not(.sample-preview-dialog) {
    width: 98% !important;
    margin-top: 5vh !important;
  }

  /* ── Sample preview dialog ── */
  .sample-preview-img {
    max-height: 55vh;
    border-radius: 6px;
  }
  ::v-deep .sample-preview-dialog.el-dialog {
    max-width: 98vw;
    border-radius: 8px;
  }
  ::v-deep .sample-preview-dialog .el-dialog__headerbtn {
    top: 6px;
    right: 6px;
    width: 24px;
    height: 24px;
  }

  /* ── Breadcrumb ── */
  .card-address_page {
    padding: 8px 12px !important;
  }
  ::v-deep .el-breadcrumb {
    font-size: 12px;
  }

  /* ── Container padding ── */
  .container {
    padding-left: 10px;
    padding-right: 10px;
  }
}

/* ══════════════════════════════════════════════════════════
   RESPONSIVE — EXTRA SMALL PHONE (≤360px)
   ══════════════════════════════════════════════════════════ */
@media (max-width: 360px) {
  .vp-branch-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .vp-branch-tile__body {
    flex-direction: row;
    text-align: left;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
  }
  .vp-branch-tile__name {
    flex: 1;
    min-height: auto;
    margin: 0;
    font-size: 12px;
  }
  .vp-branch-tile__icon {
    margin-bottom: 0;
  }
  .vp-branch-tile__stats {
    margin-bottom: 0;
  }
  .vp-branch-tile__btn {
    width: auto;
    padding: 5px 14px;
  }

  .ariza-photo-uploads-row {
    flex-direction: row;
    justify-content: center;
  }
  .ariza-photo-uploader {
    width: 90px;
    height: 108px;
  }
  .ariza-photo-uploader__icon {
    width: 90px;
    height: 108px;
    line-height: 108px;
    font-size: 22px;
  }

  .vd-vacancy-card__dates {
    flex-direction: column;
    gap: 4px;
  }

  ::v-deep .ariza-dialog {
    margin: 0 !important;
    border-radius: 0;
    width: 100vw !important;
    max-height: 100vh;
  }
}

/* ══════════════════════════════════════════════════════════
   TOUCH & INTERACTION ENHANCEMENTS
   ══════════════════════════════════════════════════════════ */
@media (hover: none) and (pointer: coarse) {
  /* Increase tap targets on touch devices */
  .vp-branch-tile__btn {
    min-height: 38px;
  }
  .vd-vacancy-card__btn {
    min-height: 40px;
  }
  .ariza-btn-upload {
    min-height: 38px;
  }
  .ariza-btn-cancel,
  .ariza-btn-submit {
    min-height: 42px;
  }
  .vp-btn-oneid {
    min-height: 42px;
  }
  .vp-btn-apps,
  .vp-btn-logout {
    min-height: 38px;
  }

  /* Disable hover transforms on touch */
  .vp-branch-tile:hover {
    transform: none;
  }
  .vd-vacancy-card:hover {
    transform: none;
  }
  .ariza-btn-submit:hover,
  .vp-btn-oneid:hover,
  .vp-btn-logout:hover {
    transform: none;
  }

  /* Active states for touch feedback */
  .vp-branch-tile:active {
    transform: scale(0.97);
    box-shadow: 0 2px 8px rgba(58, 124, 192, 0.2);
  }
  .vd-vacancy-card:active {
    transform: scale(0.98);
  }
  .ariza-btn-submit:active,
  .vp-btn-oneid:active {
    transform: scale(0.97);
  }
}

/* ══════════════════════════════════════════════════════════
   SMOOTH SCROLLING & SAFE AREAS (iOS notch support)
   ══════════════════════════════════════════════════════════ */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  ::v-deep .ariza-dialog .el-dialog__footer {
    padding-bottom: calc(14px + env(safe-area-inset-bottom)) !important;
  }
  ::v-deep .vd-dialog {
    padding-bottom: env(safe-area-inset-bottom);
  }
}

/* Smooth scroll for overflow containers */
.vd-sidebar__scroll,
.vd-body,
.vd-tab-content,
.vp-stats-card {
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}
</style>
